import { render } from "./CometChatReadReceipt.vue?vue&type=template&id=ef518c8a&scoped=true"
import script from "./CometChatReadReceipt.vue?vue&type=script&lang=js"
export * from "./CometChatReadReceipt.vue?vue&type=script&lang=js"

import "./CometChatReadReceipt.vue?vue&type=style&index=0&id=ef518c8a&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef518c8a"]])

export default __exports__